import { OrderOverview } from '@/components/Order';
import { ORDER_STATUS_WITH_TYPE_TEXT } from '@/utils/constants';

export default {
  name: 'OrderConfig',
  components: {
    OrderOverview,
  },
  computed: {
    orderId() {
      return +this.$route.params.orderId;
    },
  },
  methods: {
    goBack() {
      const { query: { tab } = {} } = this.$route || {};
      const isValidTab = Object.values(ORDER_STATUS_WITH_TYPE_TEXT).includes(tab);
      const query = isValidTab ? { tab } : {};
      this.$router.push({
        path: '/order/list',
        query,
      });
    },
  },
};
